module.exports = __webpack_public_path__ + "img/space-bg.bc7841f9.png";